import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

// const baseURL = '10.0.2.104:8080'

export default {
  // 登录
  login: data => axios({ baseURL, url: '/api/oauth/login', data, method: 'post' }), // 登录
  logout: data => axios({ baseURL, url: '/api/oauth/logout', data, method: 'PUT' }), // 登出
  getEmailAuthentication: data => axios({ baseURL, url: '/api/store/open/emailAuthentication', data, method: 'post' }), // 用户注册--发送验证码
  thirdPartyAccountIsBinded: params => axios({ baseURL, url: '/api/oauth/userInfoByKeyAndType', params }), // 校验第三方登录是否被绑定
  EmailExist: data => axios({ baseURL, url: '/api/store/exitByEmail', data, method: 'post' }), // 邮箱是否存在kaka平台
  authEmailExist: data => axios({ baseURL, url: '/api/v1/store/auth/exitByEmail', data, method: 'post' }), // 邮箱是否存在
  getOpenIpInfo: () => axios({ baseURL, url: '/api/system/open/ip', method: 'get' }), // 获取ip信息

  autoLogin: params => axios({ baseURL, url: `/api/store/${params.userId}/temporary/token`, headers: { Authorization: `Bearer ${params.token}` }, method: 'get' }) // 自动登录

}
